/*
  Cart drawer extras: free shipping bar and "You might also like" upsell products.
  Both live in drawer regions that cart.js re-renders after every cart change, so these
  custom elements are re-created each time (connectedCallback runs on every refresh).
*/

// Free shipping bar: animate from the previous progress to the new one after a re-render.
if (!customElements.get('m-free-shipping')) {
  customElements.define(
    'm-free-shipping',
    class extends HTMLElement {
      connectedCallback() {
        const progress = Math.max(0, Math.min(100, parseFloat(this.dataset.progress) || 0));
        const hue = Math.round(progress * 1.2);
        const last = window.__mFreeShippingLast;

        if (last && last.progress !== progress) {
          this.style.setProperty('--fs-progress', `${last.progress}%`);
          this.style.setProperty('--fs-hue', last.hue);
          this.getBoundingClientRect(); // commit the start state so the change transitions
          requestAnimationFrame(() => {
            this.style.setProperty('--fs-progress', `${progress}%`);
            this.style.setProperty('--fs-hue', hue);
          });
        }

        window.__mFreeShippingLast = { progress, hue };
      }
    }
  );
}

// Upsell products: variant picker updates price/variant; "+" adds to cart and refreshes the drawer.
if (!customElements.get('m-cart-upsell')) {
  customElements.define(
    'm-cart-upsell',
    class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('change', this.onChange);
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onChange);
        this.removeEventListener('click', this.onClick);
      }

      onChange = (event) => {
        const select = event.target.closest('.m-cart-upsell__variant');
        if (!select) return;
        const item = select.closest('.m-cart-upsell__item');
        const option = select.options[select.selectedIndex];
        const button = item.querySelector('.m-cart-upsell__add');
        const price = item.querySelector('[data-upsell-price]');
        if (button) button.dataset.variantId = select.value;
        if (price && option && option.dataset.price) price.textContent = option.dataset.price;
      };

      onClick = async (event) => {
        const button = event.target.closest('.m-cart-upsell__add');
        if (!button || button.disabled) return;

        button.disabled = true;
        button.classList.remove('is-error');
        button.classList.add('is-loading');

        try {
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(button.dataset.variantId), quantity: 1 }] }),
          });
          if (!response.ok) {
            const data = await response.json().catch(() => ({}));
            throw new Error(data.description || data.message || 'Could not add to cart');
          }
          // cart.js (m-cart-items) re-renders the drawer, including this list, and the cart count.
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
        } catch (error) {
          console.error(error);
          button.classList.add('is-error');
          button.title = error.message;
          button.disabled = false;
        } finally {
          button.classList.remove('is-loading');
        }
      };
    }
  );
}
